import { RectangleStackIcon, FilmIcon } from "@heroicons/react/24/outline"
import { Navigate, Route, Routes } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import CollectionList from "./CollectionList"
import AddUpdateCollection from './AddUpdate'
import RouteKeys from "constants/route-keys"

const _routes: RouteElement[] = [

    {
        route: '',
        title: 'Collection',
        component: CollectionList,
        icon: FilmIcon,
        key: RouteKeys.COLLECTION,
        display: true
    },
    {
        route: '/update/:id',
        component: AddUpdateCollection,
        title: 'Update Collection',
        key: RouteKeys.COLLECTION,
        icon: FilmIcon
    },
    {
        route: '/add',
        component: AddUpdateCollection,
        title: 'Add Collection',
        key: RouteKeys.COLLECTION,
        icon: FilmIcon
    },
]

const CollectionManagment = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    {
                        _routes.map((route, index) => (
                            <Route key={index} path={`${route.route}${route.hasChild ? '/*' : ''}`} element={<route.component />} />
                        ))
                    }
                </Routes>
            </div>
        </div>
    )
}

export default CollectionManagment

